export class ToggleBackDrop {
	static readonly type = '[ui-backdrop] toggle backdrop';
}

export class ActivateBackdrop {
	static readonly type = '[ui-backdrop] activate backdrop';
}

export class DeactivateBackdrop {
	static readonly type = '[ui-backdrop] deactivate backdrop';
}
